import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function HeaderComponent() {
  const mobileNavBtnRef = useRef(null);
  const location = useLocation();
  useEffect(() => {
    const mobileNavToggleBtn = mobileNavBtnRef.current;
    const toggleMobileNav = () => {
      document.body.classList.toggle("mobile-nav-active");
      mobileNavToggleBtn.classList.toggle("bi-list");
      mobileNavToggleBtn.classList.toggle("bi-x");
    };

    if (mobileNavToggleBtn) {
      mobileNavToggleBtn.addEventListener("click", toggleMobileNav);
    }

    return () => {
      if (mobileNavToggleBtn) {
        mobileNavToggleBtn.removeEventListener("click", toggleMobileNav);
      }
    };
  }, []);
  return (
    <div>
      {/* Header Section */}
      <header
        id="header"
        className="header d-flex align-items-center fixed-top"
      >
        <div className="container-fluid container-xl position-relative d-flex align-items-center">
          <a href="/" className="logo d-flex align-items-center me-auto">
            <img src="assets/img/logosym.png" alt="" />
          </a>

          <nav id="navmenu" className="navmenu">
            <ul>
              <li>
                <a
                  className={location.pathname === "/" ? "active" : ""}
                  href="/"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  className={location.pathname === "/about" ? "active" : ""}
                  href="/about"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  className={location.pathname === "/Services" ? "active" : ""}
                  href="/Services"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  className={location.pathname === "/Careers" ? "active" : ""}
                  href="/Careers"
                >
                  Careers
                </a>
              </li>
              <li>
                <a
                  className={location.pathname === "/contact" ? "active" : ""}
                  href="/contact"
                >
                  Contact
                </a>
              </li>
            </ul>
            <i
              ref={mobileNavBtnRef}
              className="mobile-nav-toggle d-xl-none bi bi-list"
            ></i>
          </nav>

          <a className=" btn btn-getstarted" href="/contact">
            Schedule Consultation
          </a>
        </div>
      </header>
    </div>
  );
}

export default HeaderComponent;
